// MessageDetailLayoutSelector.jsx
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import useMessageDetailType from '../hook/useMessageDetailType.js';
import Loading from '../component/Loading.jsx';
import UniversalContainer from '../component/UniversalContainer.jsx';

export const MessageDetailLayoutSelector = () => {
  const layoutType = useMessageDetailType();
  const { messageId } = useParams();

  if (layoutType === 'loading') {
    return (
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
    );
  } else {
    switch (layoutType) {
      case 'story': {
        return (
          <>
            <UniversalContainer filename="StoryMessage" messageId={messageId} />
            <UniversalContainer
              filename="PostDetailJsonLd"
              messageId={messageId}
              isStoryUi
            />
          </>
        );
      }
      case 'flix': {
        return (
          <UniversalContainer filename="FlixDetail" messageId={messageId} />
        );
      }
      case 'post':
      default: {
        return (
          <>
            <UniversalContainer filename="PostDetail" postId={messageId} />
            <UniversalContainer
              filename="PostDetailJsonLd"
              messageId={messageId}
              isPostUi
            />
          </>
        );
      }
    }
  }
};

const LoadingWrapper = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default MessageDetailLayoutSelector;
